/**
 * Zeichen-Hinweis fuer Personalisierungs-Felder.
 *
 * Sagt dem Kunden SCHON BEIM TIPPEN, wenn ein Zeichen im Druck nicht ankommt —
 * statt dass die Fertigung es Tage spaeter am roten Platzhalter merkt und der
 * Support hinterhertelefonieren muss (real: Emoji-Herzen, ~4 Faelle/Monat).
 *
 * Die Regel spiegelt den Druckpfad in Zuse (Unicodecustomizationlib):
 *   druckbar   – Windows-1252, Latein-Erweitert (seit Stufe 1/2), Kyrillisch,
 *                Arabisch/Hebraeisch, Symbole/Herzen (2190-2BFF)
 *   NICHT      – Emoji, CJK, Griechisch und alles andere -> dort endet der
 *                Text heute als [UNICODE REVIEW]-Platzhalter
 *
 * Bewusst NUR ein Hinweis, keine Sperre: der Kauf darf nie an einem falschen
 * Regex scheitern. Alles in try/catch — im Zweifel passiert einfach nichts.
 *
 * Deploy: python3 scripts/zeichen_hinweis_deploy.py · Not-Aus: Asset loeschen
 * oder den Marker-Block in layout/theme.liquid entfernen.
 */
(function () {
  'use strict';

  var CP1252_EXTRA = '€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ';
  var UNSICHTBAR = /[\u00A0\u2007\u2009\u2028\u2029\u202F\u200B-\u200D\u2060\uFE00-\uFE0F\uFEFF]/;

  function druckbar(ch) {
    var c = ch.codePointAt(0);
    if (c <= 0xFF) { return true; }                                   // Latin-1
    if (CP1252_EXTRA.indexOf(ch) >= 0) { return true; }               // cp1252-Sonderzeichen
    if (UNSICHTBAR.test(ch)) { return true; }                         // wird im Druck entfernt
    if (c >= 0x0100 && c <= 0x024F) { return true; }                  // Latein-Erweitert A+B
    if (c >= 0x1E00 && c <= 0x1EFF) { return true; }                  // Latein-Erweitert Zusatz
    if (c >= 0x0400 && c <= 0x052F) { return true; }                  // Kyrillisch
    if (c >= 0x0590 && c <= 0x06FF) { return true; }                  // Hebraeisch/Arabisch
    if (c >= 0x0750 && c <= 0x077F) { return true; }                  // Arabisch Ergaenzung
    if (c >= 0x2190 && c <= 0x2BFF) { return true; }                  // Symbole, Herzen, Sterne
    return false;                                                     // Emoji, CJK, Griechisch, ...
  }

  function problemZeichen(text) {
    var out = [];
    for (var i = 0; i < text.length;) {
      var c = text.codePointAt(i);
      var ch = String.fromCodePoint(c);
      if (!druckbar(ch) && out.indexOf(ch) < 0) { out.push(ch); }
      i += ch.length;
    }
    return out;
  }

  function istPersonalisierungsFeld(el) {
    if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA')) { return false; }
    if (el.tagName === 'INPUT' && el.type && el.type !== 'text') { return false; }
    var name = el.getAttribute('name') || '';
    // Zepto-Felder (pplr_text) und alles, was als Line-Item-Property in die
    // Bestellung wandert — genau die Texte, die spaeter gedruckt werden.
    return el.classList.contains('pplr_text') || name.indexOf('properties[') === 0;
  }

  function hinweisElement(feld) {
    var next = feld.nextElementSibling;
    if (next && next.classList && next.classList.contains('cb-zeichen-hinweis')) { return next; }
    var div = document.createElement('div');
    div.className = 'cb-zeichen-hinweis';
    div.style.cssText = 'margin:4px 0 6px;padding:6px 10px;font-size:12px;line-height:1.5;'
      + 'background:#fff7ed;border:1px solid #fdba74;border-radius:6px;color:#9a3412;';
    feld.parentNode.insertBefore(div, feld.nextSibling);
    return div;
  }

  function pruefe(feld) {
    try {
      var schlecht = problemZeichen(feld.value || '');
      var vorhanden = feld.nextElementSibling && feld.nextElementSibling.classList
        && feld.nextElementSibling.classList.contains('cb-zeichen-hinweis')
        ? feld.nextElementSibling : null;
      if (schlecht.length === 0) {
        if (vorhanden) { vorhanden.parentNode.removeChild(vorhanden); }
        return;
      }
      var el = hinweisElement(feld);
      var liste = schlecht.slice(0, 5).join(' ');
      el.textContent = '⚠️ ' + (schlecht.length === 1
        ? '„' + liste + '“ können wir leider nicht drucken — das Zeichen kommt nicht mit aufs Produkt.'
        : '„' + liste + '“ können wir leider nicht drucken — diese Zeichen kommen nicht mit aufs Produkt.');
    } catch (e) { /* Hinweis ist optional — nie den Konfigurator stoeren */ }
  }

  document.addEventListener('input', function (e) {
    if (istPersonalisierungsFeld(e.target)) { pruefe(e.target); }
  }, true);

  // Felder, die schon beim Laden gefuellt sind (Zurueck-Navigation, Autofill)
  var start = function () {
    try {
      var felder = document.querySelectorAll('input.pplr_text, input[name^="properties["], textarea[name^="properties["]');
      for (var i = 0; i < felder.length; i++) {
        if ((felder[i].value || '') !== '') { pruefe(felder[i]); }
      }
    } catch (e) { /* s.o. */ }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
